/**
 * Homepage layout variant resolver.
 * Phase 5 may return `compact` once Phase 0 O1 trigger is locked.
 */

export type HomepageLayoutVariant = "full" | "compact";

export type ResolveHomepageLayoutVariantInput = {
  /** Reserved for Phase 5 compact trigger (O1). */
  isAuthenticated?: boolean;
  hasProfileLocation?: boolean;
};

/**
 * Guest / default: full browse-first landing.
 * Compact is stubbed until Phase 5 (O1).
 */
export function resolveHomepageLayoutVariant(
  _input: ResolveHomepageLayoutVariantInput = {},
): HomepageLayoutVariant {
  return "full";
}
